import { render, staticRenderFns } from "./ProductSales.vue?vue&type=template&id=da22f52e&"
import script from "./ProductSales.vue?vue&type=script&lang=ts&"
export * from "./ProductSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports